import { FC, useCallback } from 'react';
import styles from './WidgetMenu.module.css';
import { cn } from '@/lib/utils';

import { Card } from '@/lib/types/constants';
import { useAppDispatch } from '@/lib/hooks/hooks';
import { openDialog } from '@/redux/slices/pageSlice';
import { useParams } from 'react-router';
import Ideas from '../ui/icons/new/Ideas';
import Document from '../ui/icons/new/Document';
// import Chat from '../ui/icons/widgets/Chat';
import CommentsDrawer from '../Drawers/CommentsDrawer/CommentsDrawer';

interface WidgetMenuProps {
	setSectionData: React.Dispatch<React.SetStateAction<Record<string, Card[]>>>;
	commentCount: number;
}

const WidgetMenu: FC<WidgetMenuProps> = ({ setSectionData, commentCount }) => {
	const dispatch = useAppDispatch();
	const { nodeId } = useParams();

	const handleAddIdea = useCallback(() => {
		if (!nodeId) return;
		const newCard: Card = {
			type: 'idea',
			content: '',
		};

		setSectionData((prev) => {
			const prevCards = prev[nodeId] || [];
			return { ...prev, [nodeId]: [...prevCards, newCard] };
		});
	}, [nodeId]);

	return (
		<ul className={cn(styles.menu, 'flex gap-4 items-center')}>
			<li
				onClick={handleAddIdea}
				className="ideas flex items-center h-8 bg-[#EAF1FC] rounded-lg px-3 py-1.5 gap-2 animated-hover-effect cursor-pointer"
			>
				<Ideas />
				<p className="text-sm font-bold text-primary">Ideas</p>
			</li>
			<li
				onClick={() =>
					dispatch(
						openDialog({
							type: 'addDocuments',
							addDocumentType: 'attachSectionDocument',
						})
					)
				}
				className="documents flex items-center h-8 bg-[#EAF1FC] rounded-lg px-3 py-1.5 gap-2 animated-hover-effect cursor-pointer"
			>
				<Document />
				<p className="text-sm font-bold text-primary">Documents</p>
			</li>
			<div className="w-[1px] h-6 bg-[#D3DDE2]"></div>
			<li className="relative h-8 w-8 comments">
				<CommentsDrawer commentCount={commentCount} />
			</li>
		</ul>
	);
};

export default WidgetMenu;
